const element = document.createElement('textarea');

export default (string) => {
  element.innerHTML = string;

  return element.textContent;
};
